function r(e, a) {
  var o = (65535 & e) + (65535 & a),
    t = (e >> 16) + (a >> 16) + (o >> 16);
  return t << 16 | 65535 & o
}

function n(e, a) {
  return e << a | e >>> 32 - a
}

function c(e, a, o, t, i, c) {
  return r(n(r(r(a, e), r(t, c)), i), o)
}

function d(e, a, o, t, i, r, n) {
  return c(a & o | ~a & t, e, a, i, r, n)
}

function s(e, a, o, t, i, r, n) {
  return c(a & t | o & ~t, e, a, i, r, n)
}

function p(e, a, o, t, i, r, n) {
  return c(a ^ o ^ t, e, a, i, r, n)
}

function f(e, a, o, t, i, r, n) {
  return c(o ^ (a | ~t), e, a, i, r, n)
}

function u(e, a) {
  e[a >> 5] |= 128 << a % 32,
    e[(a + 64 >>> 9 << 4) + 14] = a;
  var o, t, i, n, c, u = 1732584193,
    g = -271733879,
    b = -1732584194,
    l = 271733878;
  for (o = 0; o < e.length; o += 16)
    t = u,
      i = g,
      n = b,
      c = l,
      u = d(u, g, b, l, e[o], 7, -680876936),
      l = d(l, u, g, b, e[o + 1], 12, -389564586),
      b = d(b, l, u, g, e[o + 2], 17, 606105819),
      g = d(g, b, l, u, e[o + 3], 22, -1044525330),
      u = d(u, g, b, l, e[o + 4], 7, -176418897),
      l = d(l, u, g, b, e[o + 5], 12, 1200080426),
      b = d(b, l, u, g, e[o + 6], 17, -1473231341),
      g = d(g, b, l, u, e[o + 7], 22, -45705983),
      u = d(u, g, b, l, e[o + 8], 7, 1770035416),
      l = d(l, u, g, b, e[o + 9], 12, -1958414417),
      b = d(b, l, u, g, e[o + 10], 17, -42063),
      g = d(g, b, l, u, e[o + 11], 22, -1990404162),
      u = d(u, g, b, l, e[o + 12], 7, 1804603682),
      l = d(l, u, g, b, e[o + 13], 12, -40341101),
      b = d(b, l, u, g, e[o + 14], 17, -1502002290),
      g = d(g, b, l, u, e[o + 15], 22, 1236535329),
      u = s(u, g, b, l, e[o + 1], 5, -165796510),
      l = s(l, u, g, b, e[o + 6], 9, -1069501632),
      b = s(b, l, u, g, e[o + 11], 14, 643717713),
      g = s(g, b, l, u, e[o], 20, -373897302),
      u = s(u, g, b, l, e[o + 5], 5, -701558691),
      l = s(l, u, g, b, e[o + 10], 9, 38016083),
      b = s(b, l, u, g, e[o + 15], 14, -660478335),
      g = s(g, b, l, u, e[o + 4], 20, -405537848),
      u = s(u, g, b, l, e[o + 9], 5, 568446438),
      l = s(l, u, g, b, e[o + 14], 9, -1019803690),
      b = s(b, l, u, g, e[o + 3], 14, -187363961),
      g = s(g, b, l, u, e[o + 8], 20, 1163531501),
      u = s(u, g, b, l, e[o + 13], 5, -1444681467),
      l = s(l, u, g, b, e[o + 2], 9, -51403784),
      b = s(b, l, u, g, e[o + 7], 14, 1735328473),
      g = s(g, b, l, u, e[o + 12], 20, -1926607734),
      u = p(u, g, b, l, e[o + 5], 4, -378558),
      l = p(l, u, g, b, e[o + 8], 11, -2022574463),
      b = p(b, l, u, g, e[o + 11], 16, 1839030562),
      g = p(g, b, l, u, e[o + 14], 23, -35309556),
      u = p(u, g, b, l, e[o + 1], 4, -1530992060),
      l = p(l, u, g, b, e[o + 4], 11, 1272893353),
      b = p(b, l, u, g, e[o + 7], 16, -155497632),
      g = p(g, b, l, u, e[o + 10], 23, -1094730640),
      u = p(u, g, b, l, e[o + 13], 4, 681279174),
      l = p(l, u, g, b, e[o], 11, -358537222),
      b = p(b, l, u, g, e[o + 3], 16, -722521979),
      g = p(g, b, l, u, e[o + 6], 23, 76029189),
      u = p(u, g, b, l, e[o + 9], 4, -640364487),
      l = p(l, u, g, b, e[o + 12], 11, -421815835),
      b = p(b, l, u, g, e[o + 15], 16, 530742520),
      g = p(g, b, l, u, e[o + 2], 23, -995338651),
      u = f(u, g, b, l, e[o], 6, -198630844),
      l = f(l, u, g, b, e[o + 7], 10, 1126891415),
      b = f(b, l, u, g, e[o + 14], 15, -1416354905),
      g = f(g, b, l, u, e[o + 5], 21, -57434055),
      u = f(u, g, b, l, e[o + 12], 6, 1700485571),
      l = f(l, u, g, b, e[o + 3], 10, -1894986606),
      b = f(b, l, u, g, e[o + 10], 15, -1051523),
      g = f(g, b, l, u, e[o + 1], 21, -2054922799),
      u = f(u, g, b, l, e[o + 8], 6, 1873313359),
      l = f(l, u, g, b, e[o + 15], 10, -30611744),
      b = f(b, l, u, g, e[o + 6], 15, -1560198380),
      g = f(g, b, l, u, e[o + 13], 21, 1309151649),
      u = f(u, g, b, l, e[o + 4], 6, -145523070),
      l = f(l, u, g, b, e[o + 11], 10, -1120210379),
      b = f(b, l, u, g, e[o + 2], 15, 718787259),
      g = f(g, b, l, u, e[o + 9], 21, -343485551),
      u = r(u, t),
      g = r(g, i),
      b = r(b, n),
      l = r(l, c);
  return [u, g, b, l]
}

function g(e) {
  var a, o = "",
    t = 32 * e.length;
  for (a = 0; a < t; a += 8)
    o += String.fromCharCode(e[a >> 5] >>> a % 32 & 255);
  return o
}

function b(e) {
  var a, o = [];
  for (o[(e.length >> 2) - 1] = void 0,
    a = 0; a < o.length; a += 1)
    o[a] = 0;
  var t = 8 * e.length;
  for (a = 0; a < t; a += 8)
    o[a >> 5] |= (255 & e.charCodeAt(a / 8)) << a % 32;
  return o
}

function l(e) {
  return g(u(b(e), 8 * e.length))
}

function m(e, a) {
  var o, t, i = b(e),
    r = [],
    n = [];
  for (r[15] = n[15] = void 0,
    i.length > 16 && (i = u(i, 8 * e.length)),
    o = 0; o < 16; o += 1)
    r[o] = 909522486 ^ i[o],
      n[o] = 1549556828 ^ i[o];
  return t = u(r.concat(b(a)), 512 + 8 * a.length),
    g(u(n.concat(t), 640))
}

function w(e) {
  var a, o, t = "0123456789abcdef",
    i = "";
  for (o = 0; o < e.length; o += 1)
    a = e.charCodeAt(o),
      i += t.charAt(a >>> 4 & 15) + t.charAt(15 & a);
  return i
}

function x(e) {
  return unescape(encodeURIComponent(e))
}

function k(e) {
  return l(x(e))
}

function h(e) {
  return w(k(e))
}

function y(e, a) {
  return m(x(e), x(a))
}

function v(e, a) {
  return w(y(e, a))
}
const md5 = function (e, a, o) {
  return a ? o ? y(a, e) : v(a, e) : o ? k(e) : h(e)
}

function getMD5Config(key, tel, type) {
  "use strict";
  var config = {}
  switch (key) {
    case 'limishuxue':
      config = {
        appid: '1000001',
        appkey: 'limishuxue.com'
      }
      break;
    case 'limilaoshi':
      config = {
        appid: '1000002',
        appkey: 'limilaoshi.com'
      }
      break;
    case 'limixuexi':
      config = {
        appid: '1000003',
        appkey: 'limixuexi.com'
      }
      break;
    case 'mlimishuxue.com':
      config = {
        appid: '1000004',
        appkey: 'm.limishuxue.com'
      }
      break;
    case 'mplimixuexi':
      config = {
        appid: '1000005',
        appkey: 'mplimixuexi'
      }
      break;
    case 'applimilaoshi':
      config = {
        appid: '1000006',
        appkey: 'app.limilaoshi'
      }
      break;
    case 'applimixuexi':
      config = {
        appid: '1000007',
        appkey: 'app.limixuexi'
      }
      break;
    case 'mpactivity':
      config = {
        appid: '1000008',
        appkey: 'mpactivity'
      }
      break;
    case 'mplimicompetition':
      config = {
        appid: '1000009',
        appkey: 'mplimicompetition'
      }
      break;
    case 'limiketang':
      config = {
        appid: '120000',
        appkey: 'ketang_app'
      }
      break;
    case 'limifudao':
      config = {
        appid: '120002',
        appkey: 'limifudao'
      }
      break;

    default:
      config = {
        appid: '10000000',
        appkey: 'limi'
      }
  }
  config.type = type || 3
  config.tel = tel || 10000000000
  return md5(config.appid + config.appkey + config.tel + config.type) + Date.now()
}

export default getMD5Config;



// WEBPACK FOOTER //
// ./src/js/md5.js